// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"0a533ccd","644":"6477deb9"}[chunkId] + ".chunk.js";
};